<div #loader class="loader" [class.show]="show" [class.absolute]="absolute" [class.full-height]="fullHeight">
    <div class="loader-content">
        <div class="spinner"></div>
        <div class="spinner" style="opacity: 0.2"></div>
        <div class="spinner" style="opacity: 0.2"></div>
        <div class="spinner" style="opacity: 0.2"></div>
        @if (message) {
            <div class="message" [innerHTML]="message"></div>
        }
    </div>
</div>
